import { render, staticRenderFns } from "./QuickEmailHelp.vue?vue&type=template&id=1bfbffd1&scoped=true&"
import script from "./QuickEmailHelp.vue?vue&type=script&lang=js&"
export * from "./QuickEmailHelp.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/quickemail_stylesheet.css?vue&type=style&index=0&lang=css&"
import style1 from "@/assets/css/quickemail_reset.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfbffd1",
  null
  
)

export default component.exports